import Vue from 'vue/dist/vue.esm';
const axios = require('axios');


const createVehicle = {
    __id        : 'vueCreateVehicle',
    _element    : null,
    app         : null,
    init() {
        const el = document.getElementById('vueCreateVehicle');

        if (el) {
            new Vue({
                delimiters: ['@{', '}'],
                el: '#vueCreateVehicle',
                data: {
                    regNumber : null,
                    regNumberInput : null,
                    data : null,
                    error : null
                },
                methods :
                {
                    preventSubmit()
                    {
                        if (this.regNumberInput && !this.data) {
                            this.findVehicle();
                        } else {
                            document.getElementById("createVehicleForm").submit();
                        }
                    },

                    findVehicle()
                    {
                        this.regNumberInput = this.regNumberInput.replaceAll(' ', '');

                        if (this.regNumberInput) {
                            this.error = null;
                            this.regNumber = null;
                            this.data = null;
                            const route = '/actions/mm/regnr/get-vehicle';
                            const queryString = '?reg_number='+this.regNumberInput;

                            const url = route+queryString;

                            axios.get(url)
                            .then(this.findVehicle__callback)
                            .catch(function (error) {});
                        }
                    },

                    findVehicle__callback(response)
                    {
                        console.log(response);
                        if (typeof response==='object' && typeof response.data === 'object') {
                            this.data = response.data.item;
                            this.regNumber = this.regNumberInput;
                        } else {
                            this.error = true;
                        }
                    }
                },
                created()
                {}
            });
        }

    },
    reload() {
        return this.init();
    }
};

export { createVehicle };